export enum HeadlessParent {
  OUTSIDE_WATCH,
  OUTSIDE_LEARN
}
